import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import CountertopsIcon from '@mui/icons-material/Countertops';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import theme from '@ui/theme';
import React from 'react';

import useStyles from './StagingIncludes.style';

const CountertopsIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: theme.palette.tertiary.main, borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <CountertopsIcon sx={{ fontSize: 30 }} />
    </Box>
  );
};

const CleaningServicesIconWrapper = () => {
  return (
    <Box sx={{ backgroundColor: '#EDC687', borderRadius: '50%', width: 80, height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
      <CleaningServicesIcon sx={{ fontSize: 30 }} />
    </Box>
  );
};

const stagingIncludes = [
  {
    icon: CountertopsIconWrapper,
    caption: 'Listing Cleaning'
  },
  {
    icon: CleaningServicesIconWrapper,
    caption: 'Closing Cleaning'
  },
];

const StagingIncludes: React.FC = () => {
  const { classes } = useStyles();

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: theme.spacing(2)
      }}
    >
      {stagingIncludes.map((si, i) => {
        return (
          <div
            key={i}
            style={{
              display: 'flex',
              flex: '0 0 calc(35% - 20px)',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            className={classes.root}
          >
            <si.icon />
            <Typography className={classes.caption}>
              {si.caption}
            </Typography>
          </div>
        );
      })}
    </div>
  );
};

export default StagingIncludes;
